import React from 'react'
import './App.css';

const Navbar = () => {
  return (
    <div className='navbar'>
        Scotty Shirts U Illustrate (SSUI)
    </div>
  )
}

export default Navbar